import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { TableComponent } from "../../../shared/components/table/table.component";
import { AsyncPipe, CurrencyPipe, KeyValuePipe, NgForOf, NgIf } from "@angular/common";
import { TableService } from "../../../core/services/table.service";
import {
  NgbDropdown,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbPagination
} from "@ng-bootstrap/ng-bootstrap";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Observable } from "rxjs";
import { CustomizeTableComponent } from "./customize-table/customize-table.component";

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    TableComponent,
    NgForOf,
    NgIf,
    CurrencyPipe,
    AsyncPipe,
    NgbPagination,
    ReactiveFormsModule,
    FormsModule,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem,
    CustomizeTableComponent,
    KeyValuePipe
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent {
  public active = 1;
  configurationTable: any = {
    "columns": [
      {
        "id": "vehicles.id",
        "title": "Id",
        "type": "text",
        "hide": false,
        "category": "General"
      },
      {
        "id": "vehicles.plates",
        "title": "Placas",
        "type": "text",
        "hide": false,
        "category": "General"
      },
      {
        "id": "vehicles.niv",
        "title": "NIV",
        "type": "text",
        "hide": false,
        "category": "General"
      },
      {
        "id": "vehicles.ns",
        "title": "Nº Serie",
        "type": "text",
        "placeholder": "",
        "hide": false,
        "category": "General"
      },
      {
        "id": "vehicles.year",
        "title": "Año",
        "type": "text",
        "hide": false,
        "category": "General"
      },
      {
        "id": "brandTab.configurableListsCode",
        "title": "Marca",
        "type": "text",
        "hide": true,
        "category": "General"
      },
      {
        "id": "subbTab.configurableListsCode",
        "title": "Submarca",
        "type": "text",
        "hide": true,
        "category": "General"
      },
      {
        "id": "category_vehicle.description",
        "title": "Categoría",
        "type": "text",
        "hide": true,
        "category": "General"
      },
      {
        "id": "versionTab.configurableListsCode",
        "title": "Versión",
        "type": "text",
        "hide": false,
        "category": "General"
      },
      {
        "id": "vehicles.transmission",
        "title": "Transmisión",
        "type": "text",
        "hide": false,
        "category": "General"
      },
      {
        "id": "vehicles.maintenanceKm",
        "title": "Kilometraje",
        "type": "text",
        "hide": true,
        "category": "General"
      },
      {
        "id": "vehicles.color",
        "title": "Color Exterior",
        "type": "text",
        "hide": true,
        "category": "General"
      },
      {
        "id": "vehicles.interiorColor",
        "title": "Color Interior",
        "type": "text",
        "hide": false,
        "category": "General"
      },
      {
        "id": "vehicles.fuelTag",
        "title": "T. Combustible",
        "type": "text",
        "hide": true,
        "category": "General"
      },
      {
        "id": "vehicle_procedures.insurancePolicy",
        "title": "Póliza",
        "type": "text",
        "hide": true,
        "category": "Seguro"
      },
      {
        "id": "vehicle_procedures.insuranceInitialPayment",
        "title": "Pago Inicial",
        "type": "currency",
        "hide": false,
        "category": "Seguro"
      },
      {
        "id": "vehicle_procedures.insuranceMonthlyPayment",
        "title": "Pago mensual",
        "type": "currency",
        "hide": false,
        "category": "Seguro"
      },
      {
        "id": "vehicle_procedures.insuranceValidity",
        "title": "Vigencia",
        "type": "text",
        "hide": true,
        "category": "Seguro"
      },
      {
        "id": "cityVehicleProcedure.configurableListsCode",
        "title": "Ciudad",
        "type": "text",
        "hide": true,
        "category": "Emplacamiento"
      },
      {
        "id": "vehicle_procedures.verificationFolio",
        "title": "Folio",
        "type": "currency",
        "hide": true,
        "category": "Verificación"
      },
      {
        "id": "vehicle_procedures.verificationExpirationDate",
        "title": "Fecha Vencimiento",
        "type": "text",
        "hide": true,
        "category": "Verificación"
      },
      {
        "id": "vehicle_procedures.voluntaryVerificationFolio",
        "title": "Folio Voluntario",
        "type": "text",
        "hide": false,
        "category": "Folio Voluntario"
      },
      {
        "id": "vehicle_procedures.voluntaryVerificationValidity",
        "title": "Vigencia Voluntario",
        "type": "text",
        "hide": false,
        "category": "Verificación"
      },
      {
        "id": "leasing.contractNumber",
        "title": "Contrato",
        "type": "text",
        "hide": true,
        "category": "Leasing"
      },
      {
        "id": "leasing.expirationDate",
        "title": "Fecha Vencimiento",
        "type": "text",
        "hide": true,
        "category": "Leasing"
      },
      {
        "id": "leasing.term",
        "title": "Plazo",
        "type": "text",
        "hide": false,
        "category": "Leasing"
      },
      {
        "id": "leasing.commission",
        "title": "Comisión",
        "type": "text",
        "hide": false,
        "category": "Leasing"
      },
      {
        "id": "leasing.consideration",
        "title": "Contraprestación",
        "type": "text",
        "hide": false,
        "category": "Leasing"
      },
      {
        "id": "leasing.estimatedResidual",
        "title": "Residual Estimado",
        "type": "text",
        "hide": false,
        "category": "Leasing"
      },
      {
        "id": "vehicles.startOperationsDate",
        "title": "Fecha Inicio ",
        "type": "text",
        "hide": true,
        "category": "Alta"
      },
      {
        "id": "vehicles.initialKm",
        "title": "KM Inicial",
        "type": "text",
        "hide": true,
        "category": "Alta"
      },
      /*{
        "id": "capacity",
        "title": "Capacidad",
        "condition": "GROUP_CONCAT(DISTINCT configurableLists.configurableListsCode ORDER BY configurableLists.configurableListsCode ASC)",
        "isHaving": true,
        "onlyTable": true
      },
      {
        "id": "",
        "title": "Capacidad",
        "onlyForm": true,
        "type": "multiselect",
        "placeholder": "Seleccione",
        "serviceConfig": {
          "table": "confList",
          "idColumn": "idconfigurableLists",
          "valueColumn": "configurableListsCode",
          "conditionColumn":"configurableListsField",
          "conditionValue":"Categoría capacidad"
        },
        "required": false
      },*/
      {
        "btnName": "Opciones",
        "actions": [
          {
            "btnName": "Editar evento",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              //"fn": this.editCategory.bind(this)
            },
            "type": {
              "type": "btn-icon",
              "class": 'btn-pill btn-outline-success border border-success',
              "icons": 'edit'
            }
          },
          /*{
            "btnName": "Editar",
            "textConfirmation": "¿Desea desactivar al usuario seleccionado?",
            "action": {
              "type": "update"
            }
          },*/
          {
            "btnName": "Eliminar",
            "textConfirmation": "¿Desea eliminar el usuario seleccionado?",
            "action": {
              "type": "delete"
            }
          }
        ]
      }
    ],
    "config": "vehicles",
    "sortColumn": "vehicles.niv",
    "sortDirection": "ASC",
    "title": "Vehículos",
    "filterPrincipal": [{
      "column": "vehicles.status",
      "operator": "=",
      "value": this.active
    }
    ],
    "filters": []
  };

  categoriesCountArray: { key: string, number: number }[] = [];

  public dataTable: any[] = [];
  columns: any[] = [];
  public total$: Observable<number>;
  excludeKeys = ["vehicles.id", "vehicles.niv", "vehicles.plates", "vehicles.ns"];
  keys: string[] = [];//array para columnas personalizadas por rol de usuario.

  constructor(public service: TableService, private cdr: ChangeDetectorRef) {
    this.total$ = service.total$;
  }
  ngOnInit() {
    //this.createHeaderTable();
    this.loadData();
  }

  createHeaderTable(thereData: any) {
    const categoriesCount = this.configurationTable.columns.reduce((acc: any, col: any) => {
      if (thereData) { //Si se encontraron resultados crea el header de la tabla en base a las columnas del objeto
        if (this.keys.includes(col.id)) {
          acc[col.category] = (acc[col.category] || 0) + 1;
        }
      } else {//Si no se encontraron resultados crea el header de la tabla en base a las columnas especificas
        if (col.hide) {
          acc[col.category] = (acc[col.category] || 0) + 1;
        }
      }
      return acc;
    }, {} as { [key: string]: number });

    this.categoriesCountArray = Object.keys(categoriesCount).map(key => ({
      key,
      number: categoriesCount[key]
    }));
  }
  loadData() {
    let thereData = false;
    this.dataTable = [];
    this.columns = this.configurationTable.columns.filter((item: any) => !item['onlyForm']);
    this.cdr.detectChanges();
    this.service.generateData(this.configurationTable);
    this.service.searchTerm = "";
    this.service.getList$.subscribe((data: any) => {
      if (data) {
        if (!Array.isArray(data) || data.length === 0) {
          this.dataTable = [];
          this.createHeaderTable(false);
          return;
        }

        thereData = true;
        this.dataTable = data;
        //Se obtienen las columnas a mostrar por rol de usuario
        const exclude = ["vehicles.id", "vehicles.niv", "vehicles.plates", "vehicles.ns"];
        this.keys = Object.keys(data[0]).filter(key => !exclude.includes(key));
      }
      this.createHeaderTable(thereData);
    });

  }

  changeStatus(data: any) {
    this.active = data;
    this.configurationTable.filterPrincipal[0].value = this.active;
    this.loadData();
  }

}
